/* ===================================================================
   Lambda Coffee — Warenkorb Cross-Sell
   "+"-Klick → Ajax /cart/add.js (mit Sections) → kurze Bestätigung
   ("Gute Entscheidung") → Dawns cart-drawer.renderContents() rendert
   #CartDrawer neu; der MutationObserver in eg-cart-goal aktualisiert
   dabei automatisch die Gratis-Versand-Leiste. Event-Delegation auf
   document, damit der Handler die Re-Renders überlebt.
   =================================================================== */
(function () {
  if (window.__lcXsellInit) return;
  window.__lcXsellInit = true;

  var FEEDBACK_MS = 1100;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lc-xsell-add]');
    if (!btn) return;
    e.preventDefault();

    var xsell = btn.closest('[data-lc-xsell]');
    var cartDrawer = document.querySelector('cart-drawer');
    var variantId = btn.getAttribute('data-variant-id');
    if (!xsell || !cartDrawer || !variantId) return;
    if (xsell.classList.contains('is-loading') || xsell.classList.contains('is-added')) return;

    xsell.classList.add('is-loading');

    var sectionIds = typeof cartDrawer.getSectionsToRender === 'function'
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          xsell.classList.remove('is-loading');
          return;
        }
        xsell.classList.remove('is-loading');
        xsell.classList.add('is-added');
        setTimeout(function () {
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          }
        }, FEEDBACK_MS);
      })
      .catch(function () {
        xsell.classList.remove('is-loading');
      });
  });
})();
